"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.COL_LONG_TEXT, (table)=>{
        table.string('id', 20).primary();
        table.string('fk_workspace_id', 20);
        table.string('base_id', 20);
        table.string('fk_model_id', 20);
        table.string('fk_column_id', 20);
        table.string('fk_integration_id', 20);
        table.string('model', 255);
        table.text('prompt');
        table.text('prompt_raw');
        table.text('error');
        table.timestamps(true, true);
        table.index('fk_column_id');
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.COL_LONG_TEXT);
};
